import React from "react";
import { Text, Skeleton } from "@chakra-ui/react";
import { useFetchQueryCount } from "../../api/fetchData";

const Count = ({ module, select='COUNT(*)', query=null }) => {
    const { count } = useFetchQueryCount(module, select, query);

    // if ( !data ) {
    //     return <Skeleton fadeDuration={5} height='20px' isLoaded={data} />
    // }

    return (
        <Skeleton fadeDuration={5} height='20px' isLoaded={count} >
            {count && <Text fontWeight='bold'>{count}</Text>}
        </Skeleton>
    );
};

export default Count;